import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { TeamSessionsService } from '@nimbus-portal/features/historical-sessions/services/team-sessions.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { IPermissionFilterParameters, PermissionFilter } from '@nimbus-global/features/menu/services/filters/permission.filter';
import { IMenuFilter } from '@nimbus-library/features/menu';

export class HistoricalSessionsEnabledFilter implements IMenuFilter {
  public constructor(
    private readonly store: Store,
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionManagerService: IPermissionManagerService,
    private readonly injector: Injector,
  ) {}

  public static for(parameter: IPermissionFilterParameters): {
    type: typeof HistoricalSessionsEnabledFilter;
    option: IPermissionFilterParameters;
  } {
    return { type: HistoricalSessionsEnabledFilter, option: parameter };
  }

  public validate$(parameter: IPermissionFilterParameters): Observable<boolean> {
    const permissionsFilter = new PermissionFilter(this.store, this.authenticationService, this.permissionManagerService);

    return permissionsFilter.validate$(parameter).pipe(
      switchMap((isValidPermission) => {
        if (isValidPermission) {
          const isAuthenticated = this.authenticationService.isAuthenticated$.value;

          if (isAuthenticated) {
            const userId = this.authenticationService.getUserInfo()?.userId;
            const teamSessionsService = this.injector.get(TeamSessionsService);
            return teamSessionsService.getAvailableHistoricalSessionsTeams(userId).pipe(map((result) => result?.length > 0));
          } else {
            return of(false);
          }
        }
        return of(false);
      }),
    );
  }
}
